import React from 'react';
import { useTranslations } from 'next-intl';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';

const SecurityLogo = React.memo(() => {
  const t = useTranslations('uhHome');
  return (
    <img
      src={getCompressedAssetUrl('/web_v2/uh-home-v2/misc/security-logo.png')}
      alt={t('securityLogo.image.alt.securityCertificationLogo')}
      width={142}
      height={176}
      style={{ display: 'block' }}
    />
  );
});

SecurityLogo.displayName = 'SecurityLogo';

export default SecurityLogo;
